const images = {
	"camera": require("../images/photo_camera-24px.svg"),
	"check": require("../images/check-24px.svg"),
	"close": require("../images/close-24px.svg"),
	"delete": require("../images/ic_delete_24px.svg"),
	"rotate": require("../images/rotate.svg"),
};

export default images;
